import { CountryAddressData } from '@square/dashboard-protos/models/squareup/address/country_data';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
export function admin1LabelTranslationKey(admin1Label, country) {
  // CountryAddressData returns "Province" for UK administrate area fields but we always want to display "County" label
  if (country === Country.GB) {
    return 'banking.shared.countryAddress.admin1Label.county';
  }
  switch (admin1Label) {
    case CountryAddressData.Admin1Scope.Admin1Label.PROVINCE:
      return 'banking.shared.countryAddress.admin1Label.province';
    case CountryAddressData.Admin1Scope.Admin1Label.AREA:
      return 'banking.shared.countryAddress.admin1Label.area';
    case CountryAddressData.Admin1Scope.Admin1Label.DEPARTMENT:
      return 'banking.shared.countryAddress.admin1Label.department';
    case CountryAddressData.Admin1Scope.Admin1Label.DISTRICT:
      return 'banking.shared.countryAddress.admin1Label.district';
    case CountryAddressData.Admin1Scope.Admin1Label.DO_SI:
      return 'banking.shared.countryAddress.admin1Label.doSi';
    case CountryAddressData.Admin1Scope.Admin1Label.EMIRATE:
      return 'banking.shared.countryAddress.admin1Label.emirate';
    case CountryAddressData.Admin1Scope.Admin1Label.ISLAND:
      return 'banking.shared.countryAddress.admin1Label.island';
    case CountryAddressData.Admin1Scope.Admin1Label.OBLAST:
      return 'banking.shared.countryAddress.admin1Label.oblast';
    case CountryAddressData.Admin1Scope.Admin1Label.PARISH:
      return 'banking.shared.countryAddress.admin1Label.parish';
    case CountryAddressData.Admin1Scope.Admin1Label.PREFECTURE:
      return 'banking.shared.countryAddress.admin1Label.prefecture';
    case CountryAddressData.Admin1Scope.Admin1Label.STATE:
      return 'banking.shared.countryAddress.admin1Label.state';
    case CountryAddressData.Admin1Scope.Admin1Label.COUNTY:
      return 'banking.shared.countryAddress.admin1Label.country';
    default:
      throw new Error('Unhandled Admin1Label value');
  }
}
export function localityLabelTranslationKey(localityLabel) {
  switch (localityLabel) {
    case CountryAddressData.LocalityScope.LocalityLabel.CITY:
      return 'banking.shared.countryAddress.localityLabel.city';
    case CountryAddressData.LocalityScope.LocalityLabel.DISTRICT:
      return 'banking.shared.countryAddress.localityLabel.district';
    case CountryAddressData.LocalityScope.LocalityLabel.POST_TOWN:
      return 'banking.shared.countryAddress.localityLabel.postTown';
    case CountryAddressData.LocalityScope.LocalityLabel.SUBURB:
      return 'banking.shared.countryAddress.localityLabel.suburb';
    case CountryAddressData.LocalityScope.LocalityLabel.TOWN_CITY:
      return 'banking.shared.countryAddress.localityLabel.townCity';
    default:
      throw new Error('Unhandled LocalityLabel value');
  }
}
export function sublocalityLabelTranslationKey(sublocalityLabel) {
  switch (sublocalityLabel) {
    case CountryAddressData.SublocalityScope.SublocalityLabel.SUBURB:
      return 'banking.shared.countryAddress.sublocalityLabel.suburb';
    case CountryAddressData.SublocalityScope.SublocalityLabel.DISTRICT:
      return 'banking.shared.countryAddress.sublocalityLabel.district';
    case CountryAddressData.SublocalityScope.SublocalityLabel.NEIGHBORHOOD:
      return 'banking.shared.countryAddress.sublocalityLabel.neighborhood';
    case CountryAddressData.SublocalityScope.SublocalityLabel.TOWNLAND:
      return 'banking.shared.countryAddress.sublocalityLabel.townland';
    case CountryAddressData.SublocalityScope.SublocalityLabel.VILLAGE_TOWNSHIP:
      return 'banking.shared.countryAddress.sublocalityLabel.villageTownship';
    case CountryAddressData.SublocalityScope.SublocalityLabel.TOWN:
      return 'banking.shared.countryAddress.sublocalityLabel.town';
    default:
      throw new Error('Unhandled SublocalityLabel value');
  }
}
export function postalCodeLabelTranslationKey(postalCodeLabel) {
  switch (postalCodeLabel) {
    case CountryAddressData.PostalCodeScope.PostalCodeLabel.POSTAL:
      return 'banking.shared.countryAddress.postalCodeLabel.postal';
    case CountryAddressData.PostalCodeScope.PostalCodeLabel.EIRCODE:
      return 'banking.shared.countryAddress.postalCodeLabel.eircode';
    case CountryAddressData.PostalCodeScope.PostalCodeLabel.PIN:
      return 'banking.shared.countryAddress.postalCodeLabel.pin';
    case CountryAddressData.PostalCodeScope.PostalCodeLabel.ZIP:
      return 'banking.shared.countryAddress.postalCodeLabel.zip';
    default:
      throw new Error('Unhandled PostalCodeLabel value');
  }
}